import Announcement from '../views/Announcement/index.vue'
import Header from '../views/Header/index.vue'
import Footer from '../views/Footer/index.vue'

export default {
    name: "App",
    metaInfo() {
        const link = [];
        link.push(
            {
                rel: 'canonical',
                href: this.canonicalUrl
            },
            {
                rel: 'alternate',
                hreflang: 'x-default',
                href: this.alternateUrl
            },
            {
                rel: 'alternate',
                hreflang: process.env.VUE_APP_LANGUAGE1,
                href: this.alternate1
            },
            {
                rel: 'alternate',
                hreflang: process.env.VUE_APP_LANGUAGE2,
                href: this.alternate2
            }
        );
        const script = []
        script.push(
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebSite", // 这里改成了 Product 类型
                    "name": this.Name,
                    "url": this.NameUrl
                }),
                vmid: 'ld-json'
            }
        )
        return {
            // 方法1：使用 link 数组
            link,
            script,
            __dangerouslyDisableSanitizers: ['script']
        }
    },

    provide() {
        return {
            reload: this.reload // 提供 reload 方法
        }
    },
    created() {
        // const savedLocale = localStorage.getItem('language')
        // if (savedLocale && this.$i18n) {
        //     this.$i18n.locale = savedLocale
        // }
        this.$nextTick(function () {
            this.alternate1 = window.location.href.replace(`?lang=${this.Language == 1 ? process.env.VUE_APP_LANGUAGE1 : process.env.VUE_APP_LANGUAGE2}`, `?lang=${process.env.VUE_APP_LANGUAGE1}`)
            this.alternate2 = window.location.href.replace(`?lang=${this.Language == 1 ? process.env.VUE_APP_LANGUAGE1 : process.env.VUE_APP_LANGUAGE2}`, `?lang=${process.env.VUE_APP_LANGUAGE2}`)
        });
    },
    mounted() {
        this.$nextTick(function () {

        })
    },
    data() {
        return {
            isRouterAlive: true, // 控制路由器视图显示
            canonicalUrl: window.location.href,
            alternateUrl: window.location.href,
            alternate1: '',
            alternate2: '',
            LANGUAGE1: process.env.VUE_APP_LANGUAGE1,
            LANGUAGE2: process.env.VUE_APP_LANGUAGE2,
            Language: localStorage.getItem('Language') || 2,
            Name: this.$route.name,
            NameUrl: window.location.href
        };
    },
    computed: {


    },
    watch: {
        $route: {
            handler: 'routeCue',
            // 深度观察监听
            deep: true
        }
    },
    methods: {
        reload() {
            this.isRouterAlive = false // 销毁路由器视图
            this.$nextTick(() => {
                this.isRouterAlive = true // 下一 tick 重建视图

            })
        },
        routeCue: function () {
            this.canonicalUrl = window.location.href
            this.alternateUrl = window.location.href
            this.alternate1 = window.location.href.replace(`?lang=${this.Language == 1 ? process.env.VUE_APP_LANGUAGE1 : process.env.VUE_APP_LANGUAGE2}`, `?lang=${process.env.VUE_APP_LANGUAGE1}`)
            this.alternate2 = window.location.href.replace(`?lang=${this.Language == 1 ? process.env.VUE_APP_LANGUAGE1 : process.env.VUE_APP_LANGUAGE2}`, `?lang=${process.env.VUE_APP_LANGUAGE2}`)
            this.Name = this.$route.name
            this.NameUrl = window.location.href
            this.$meta().refresh()
            // this.relode()
        }
    },
    components: {
        Announcement,
        Header,
        Footer
    }
};